import { render, staticRenderFns } from "./SessionAttendance.vue?vue&type=template&id=5204dbb4&"
import script from "./SessionAttendance.vue?vue&type=script&lang=js&"
export * from "./SessionAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports